import * as types from "./actionTypes";
//import * as accountApi from "../../_api/accountApi";
// import { beginApiCall, apiCallError } from "./apiStatusActions";

export function userLoginSuccess() {
  return { type: types.USER_LOGIN_SUCCESS };
}

export function userLogoutSuccess() {
  return { type: types.USER_LOGOUT_SUCCESS };
}
